import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import EditFormAutoCompleteField from 'modules/ui/editform/fields/EditFormAutoCompleteField';
import { useParams, withRouter } from 'react-router';
import UserGroupEditService from '../service/UserGroupEditService';
import FejezetEditService from 'app/admin/fejezet/service/FejezetEditService';
import { getQueriedSelection } from 'app/admin/common/util/CommonUtil';

const config = data => {
	return {
		key: 'userGroupEditForm',
		topic: 'userGroup',
		service: UserGroupEditService,
		fields: initData => {
			const fields = [
				{
					key: 'name',
					component: EditFormTextField,
					required: true,
					text: 'Név',
					readOnly: data.id !== 'new'
				},
				{
					key: 'fejezetek',
					text: 'Fejezetek',
					component: EditFormAutoCompleteField,
					multiple: true,
					// items: () => FejezetEditService.getFejezetSelection()
					query: (query, limit) => getQueriedSelection(FejezetEditService.getFejezetSelection(), query, limit)
				}
			];

			return fields;
		}
	};
};

function UserGroupEditForm() {
	const { id } = useParams();
	const myConfig = config({ id });
	return (
		<EditFormPage config={myConfig} />
	);
}

export default withRouter(UserGroupEditForm);